<p-dialog
  [header]="'case.sms.header' | translate"
  [(visible)]="showPopup"
  [modal]="true"
  [closable]="true"
  (onHide)="clearAll()"
  [style]="{ width: '45rem', 'max-height': '75vh', 'overflow-y': 'auto' }"
>
  <div class="modal-body">
    <div class="form-group">
      <label for="">{{ "case.sms.template" | translate }}</label>
      <p-dropdown
        [options]="filteredTemplates"
        [(ngModel)]="selectedTemplate"
        [filter]="true"
        (ngModelChange)="onTemplateChange($event)"
        [placeholder]="'case.sms.template-placeholder' | translate"
        optionLabel="templateName"
      >
      </p-dropdown>
    </div>

    <div class="form-group">
      <label for="">{{ "case.sms.phone" | translate }}</label>
      <div class="phone-chips" *ngIf="this.selectedTemplate">
        <div
          *ngFor="let phone of availablePhones"
          class="phone-chip mb-2"
          [class.selected]="isPhoneSelected(phone)"
          (click)="togglePhone(phone)" role="button"  tabindex="-1"
        >
          {{ phone }}
        </div>
      </div>

      <p-chips
        [allowDuplicate]="false"
        [(ngModel)]="selectedPhones"
        (onAdd)="handleChipAdd($event)"
      />
    </div>

    <div class="form-group">
      <label for="">{{ "case.sms.content" | translate }}</label>
      <app-readonly-input
        [type]="'textarea'"
        [value]="selectedContent"
      ></app-readonly-input>
    </div>
  </div>

  <ng-template pTemplate="footer">
    <button class="send-button" (click)="sendSms()">{{'common.send' | translate}}</button>
  </ng-template>
</p-dialog>
